import {HTTP_METHODS} from '../httpMethods'
import {sanitizeSearchQuery, toSafeQueryString} from '@/utils/security/pathSafety'

export const SEGMENTS_CONFIG = {
  // SEGMENTS_LIST: {
  //   endPoint: 'segment/segment-data',
  //   baseUrlKey: 'cepApiUrl',
  //   headers: {
  //     'x-api-key': import.meta.env[FeatureConfig.cepApiKey],
  //     'siteId': '21'
  //   },
  //   attachAuthIntercepter: false
  // }
  SEGMENTS_LIST: (searchQuery = '') => {
    const safeSearch = sanitizeSearchQuery(searchQuery)
    const queryString = safeSearch ? toSafeQueryString({search: safeSearch}) : ''

    return {
      endPoint: `segment/groups${queryString ? `?${queryString}` : ''}`,
      baseUrlKey: 'inventoryApiUrl',
      method: HTTP_METHODS.GET,
      headers: {
        scope: 'pepsi',
      },
    }
  },
  SEGMENTS_BASE: {
    endPoint: 'segment',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
  SEGMENTS_BY_GROUP_BASE: {
    endPoint: 'segment/groups',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
}
